import React from "react";
import { ArrowRightIcon, PhoneIcon } from "lucide-react";
import { firm, navGroups } from "../../data/site";
import { actionClass } from "../../utils/actionStyles";
import { SiteLink } from "../SiteLink";
type MobileMenuProps = {
  id: string;
  onNavigate: () => void;
};
export function MobileMenu({
  id,
  onNavigate
}: MobileMenuProps) {
  return <div id={id} className="border-t border-line bg-white nav:hidden" data-id="element-102" data-mp="1ji8e4nc9ilxe">
      <nav aria-label="Main" className="page-container py-6 md:py-8" data-id="element-103" data-mp="15jqwn7cya5nx">
        <div className="grid gap-x-10 gap-y-8 sm:grid-cols-2" data-id="element-104" data-mp="19mn90gbwd5jf">
          {navGroups.map(group => <section key={group.id} aria-labelledby={`mobile-group-${group.id}`} data-id="element-105" data-mp="vn5owe9jqgge">
              <h2 id={`mobile-group-${group.id}`} className="text-label font-bold text-slate" data-id="element-106" data-mp="10l74uqbodznn">
                {group.label}
              </h2>
              <ul className="mt-2 divide-y divide-line border-y border-line" data-id="element-107" data-mp="2q0wvf4wkwk7m">
                {group.links.map(link => <li key={link.path} data-id="element-108" data-mp="2uxdqyk63y0uq">
                    <SiteLink path={link.path} onClick={onNavigate} className="flex min-h-[52px] items-center justify-between gap-4 py-3 text-label font-semibold text-ink hover:text-crimson" data-id="element-109" data-mp="138xnk7a9ejd8">
                      <span data-id="element-110" data-mp="180pg2ncz6z60">{link.label}</span>
                      <ArrowRightIcon aria-hidden="true" className="h-5 w-5 shrink-0 text-slate" data-id="element-111" data-mp="181qv12x445t0" />
                    </SiteLink>
                  </li>)}
              </ul>
            </section>)}
        </div>
        <div className="mt-8 flex flex-col gap-3 sm:flex-row" data-id="element-112" data-mp="fe4opmwi2n2g">
          <a href="#case-review" onClick={onNavigate} className={actionClass("primary", "w-full sm:w-auto")} data-id="element-113" data-mp="tcckvslppkck">
            Free Case Review
          </a>
          <a href={firm.phoneHref} className={actionClass("call", "w-full sm:w-auto")} data-id="element-114" data-mp="24qg9ej9j6ga8">
            <PhoneIcon aria-hidden="true" className="h-5 w-5" data-id="element-115" data-mp="1zrn8dqbfkhqy" />
            Call {firm.phoneDisplay}
          </a>
        </div>
      </nav>
    </div>;
}